import styled, { StyledProps } from 'styled-components/macro';

export type CheckBoxStylesProps = StyledProps<{
  isActive?: boolean;
}>;

export const Tabs = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid #bad9e2;
`;

export const TabItem = styled.div<CheckBoxStylesProps>`
  position: relative;
  min-width: 127px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 13px;
  color: ${(props) => (props.isActive ? '#0076C0' : '#666666')};
  transition: 0.2s;
  font-weight: 500;
  svg.error {
    margin: 0 7px;
    color: #cf4845;
  }
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    transition: 0.2s;
    border-bottom: 4px solid ${(props) => (props.isActive ? '#0076C0' : '#fff')};
  }
`;

export const TabClose = styled.button`
  border: none;
  background: none;
  color: #d1d1d1;
`;
